// WP-3.3 — Service Catalogue (SVC-2). Owner-ratified 2026-06-27 — the CANONICAL Source of Truth for
// the public Service Layer (ADR-0008 §7 taxonomy SoT; ADR-0009 entity identity; SAB model).
//
// PURE DATA, NO IMPORTS → node-importable by the sitemap generator + safe for routeRegistry / seoData
// / serviceProjection / jsonld (no cycles). Slugs are ratified ASCII constants, locale-invariant
// (slug ≠ translation — ADR-0009 P4). Names are the ratified canonical English service names.
//
// Wedding Chauffeur is INTENTIONALLY EXCLUDED (silent omission — SVC-1): it must never appear in the
// public SEO surface, Service JSON-LD, sitemap, navigation, internal linking, or structured data. It
// simply is not a member of this catalogue, so nothing downstream can ever project it.

export const SERVICE_CATALOG = Object.freeze([
  Object.freeze({ order: 1, slug: 'airport-transfer', name: 'Airport Transfer' }),
  Object.freeze({ order: 2, slug: 'station-transfer', name: 'Station Transfer' }),
  Object.freeze({ order: 3, slug: 'hotel-transfer', name: 'Hotel Transfer' }),
  Object.freeze({ order: 4, slug: 'business-chauffeur', name: 'Business Chauffeur' }),
  Object.freeze({ order: 5, slug: 'chauffeur-by-the-hour', name: 'Chauffeur by the Hour' }),
  Object.freeze({ order: 6, slug: 'event-chauffeur', name: 'Event Chauffeur' }),
  Object.freeze({ order: 7, slug: 'long-distance-transfer', name: 'Long-Distance Transfer' }),
]);

export const SERVICE_BASE_PATH = '/services';
export const servicePath = (slug) => `${SERVICE_BASE_PATH}/${slug}`;
export const serviceSeoKey = (slug) => `service:${slug}`;
export const findService = (slug) => SERVICE_CATALOG.find((s) => s.slug === slug) || null;
export const findServiceByPath = (path) => SERVICE_CATALOG.find((s) => servicePath(s.slug) === path) || null;
